import React, { useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Container } from 'react-bootstrap'
import { isLoggedIn } from '../../../services/authenticationService'
import { loginPageRequest } from 'actions/authenticationActions'
import LoginOptionForm from './loginOptionForm'
import EnterCodeForm from './enterCodeForm'
import { useHistory } from 'react-router-dom'
import { updateForProposalViewFromEmail } from 'actions/emailActions'
import { clearApplicationStorage } from '../../../helpers'
import * as E from './loginElements'
import { FooterImageStyled } from 'components/styledComponents/footerImage/footerImageStyled'

const Login = () => {
  const [changedOption, updateChangedOption] = useState(false)
  const [canEnterCode, setCanEnterCode] = useState(false)
  const [option, setOption] = useState('mobile')

  const handleOptionChange = (event) => {
    setOption(event.target.value)
    updateChangedOption(true)
  }

  const history = useHistory()
  let dispatch = useDispatch()

  useEffect(() => {
    if (isLoggedIn()) {
      if(window.confirm("This action will cause you to be logged out.") == false){
        dispatch(loginPageRequest())
        history.push('/home')
      }
      else{
        // Resets and clears all the application storage
        dispatch(loginPageRequest())
        clearApplicationStorage()
        window.location.reload()
      }
    }
    
    let url = window.location.href.toLowerCase()
    if (url.indexOf('&viewproposal=true') !== -1) {
      dispatch(updateForProposalViewFromEmail())
    }
  }, [])

  return (
    <>
      <div id="page">
        <E.PageDiv>
          <E.BackgroundDiv>
            <div>
              <E.OlyLogo 
               src="/images/Oly.svg"
               alt=""
              />
            </div>
            <Container className="login-container p-5 bg-white shadow-sm">
              {!canEnterCode && (
                <LoginOptionForm
                  setCanEnterCode={setCanEnterCode}
                  handleOptionChange={handleOptionChange}
                  option={option}
                  changedOption={changedOption}
                  updateChangedOption={updateChangedOption}
                />
              )}

              {canEnterCode && (
                <EnterCodeForm
                  setCanEnterCode={setCanEnterCode}
                  option={option}
                />
              )}
            </Container>
            <FooterImageStyled />
          </E.BackgroundDiv>
        </E.PageDiv>
      </div>
    </>
  )
}

function mapStateToProps(state) {
  return {
    isAuthenticated: state.authentication.isAuthenticated,
    isGov: state.user.isGov,
  }
}

export default connect(mapStateToProps)(Login)
